/**
 * DigestRouter — handles all /digest/* paths reliably
 * - /digest/featured        → DigestFeaturedPage
 * - /digest/@username        → DigestArchivePage
 * - /digest/@username/week-slug → PublicDigestPage (canonical)
 * - /digest/<legacy-slug>   → PublicDigestPage (legacy redirect)
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import DigestFeaturedPage from './DigestFeaturedPage';
import DigestArchivePage from './DigestArchivePage';
import PublicDigestPage from './PublicDigestPage';

const DigestRouter = () => {
  const { pathname } = useLocation();
  const parts = pathname.replace(/^\/digest\/?/, '').split('/').filter(Boolean);

  // /digest/featured
  if (parts.length === 1 && parts[0] === 'featured') {
    return <DigestFeaturedPage />;
  }

  // /digest/@username/week-slug
  if (parts.length === 2 && parts[0].startsWith('@')) {
    const username = parts[0].slice(1);
    const weekSlug = parts[1];
    return <PublicDigestPage routeUsername={username} routeWeekSlug={weekSlug} />;
  }

  // /digest/@username
  if (parts.length === 1 && parts[0].startsWith('@')) {
    const username = parts[0].slice(1);
    return <DigestArchivePage routeUsername={username} />;
  }

  // /digest/<legacy-slug>
  if (parts.length === 1) {
    return <PublicDigestPage routeLegacySlug={parts[0]} />;
  }

  // Fallback
  return <DigestFeaturedPage />;
};

export default DigestRouter;
